import React from 'react';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import axios from "axios";
import {defaultVariabls} from "../../../../../config/index";
import {connect} from "trim-redux";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import {Translate} from "../../../../../config/Translate";
import withWidth from "@material-ui/core/withWidth/withWidth";
import DeleteButton from "../../../../components/elements/DeleteButton";
import MakeBannerButton from "./Make‌BannerButton";

class SlideShowItem extends React.Component {
    onDelete(id){
        let data = new FormData();
        data.append('id',  id);
        this.setState({
            loading: false
        });
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/banner/delete`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.deleteData, {
                    variant: 'success',
                });
                this.props.reload();

            })
            .catch(error => {
                console.log(error.response);
                this.props.enqueueSnackbar(Translate.deleteDataFailed, {
                    variant: 'error',
                });
                return false
            });
    }
    render(){
        let {item} = this.props;
        return (
            <div
                className="slide_show_item banner_item"
            >
                <img src={!!item ? `${defaultVariabls.uploads}/FileManager/${item.thumbnail.name}.${item.thumbnail.extension}` : ''}/>
                <div className="controller">
                    <MakeBannerButton
                        id={item.id}
                        reload={() => this.props.reload()}
                        model={this.props.model}
                    />
                    <DeleteButton
                        size="small"
                        handleDelete={() => this.onDelete(item.id)}
                    />
                </div>
            </div>
        );
    }
}

const mstp = state => ({
    locale: state.locale,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(SlideShowItem)))));